import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AuthservicesService } from '../../services/authservices.service';


@Component({
    selector: 'app-change-password',
    imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
    templateUrl: './chage-password.component.html',
    styleUrl: './chage-password.component.scss',
    standalone: true,
    providers: [AuthservicesService]
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
    maxAttempts = 5;  // Limit attempts
    attempts = 0;
    cooldownTime = 30; // Cooldown time in seconds
    isLocked = false;
    isLoading = false; // Add loading state to prevent double-click
    isSuccess = false; // Track success state
    redirectCountdown = 0; // Countdown timer for redirect
    submitted = false;
    subscription: Subscription | undefined
    errors: string[] = [];
    messages: string[] = [];
    requestPasswordForm: FormGroup;
    constructor(private fb: FormBuilder, private router: Router, private typeservice: AuthservicesService, private toastr: ToastrService) {
        this.requestPasswordForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }


    ngOnInit(): void {
        this.requestPasswordForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    // Getter to check if button should be disabled
    get isButtonDisabled(): boolean {
        return this.requestPasswordForm.invalid || this.isLoading || this.isLocked;
    }
    onSubmit(): void {
        if (this.isLocked || this.isLoading) return; // Prevent submission if locked or loading
        
        if (this.attempts < this.maxAttempts) {
            this.isLoading = true; // Disable button during API call
            
            this.typeservice.forgotpasswordPost(this.requestPasswordForm.value).subscribe({
                next: () => {
                    this.isLoading = false;
                    this.isSuccess = true;
                    this.toastr.success('Email sent if you email has been registered', 'Success!');
                    
                    // Start countdown from 10 seconds
                    this.redirectCountdown = 10;
                    
                    // Update countdown every second
                    const countdownInterval = setInterval(() => {
                        this.redirectCountdown--;
                        
                        if (this.redirectCountdown <= 0) {
                            clearInterval(countdownInterval);
                            this.router.navigate(['/auth']);
                        }
                    }, 1000);
                    
                    this.attempts = 0;
                },
                error: (error) => {
                    this.toastr.error('There has been a error', 'Error!')
                    this.attempts++;
                    this.isLoading = false; // Re-enable button on error

                    if (this.attempts >= this.maxAttempts) {
                        this.lockForm();
                    }
                    return;
                }
            });
        }
    }
    getpasswordcomponent(event: Event) {
        if (event) {
          event.preventDefault();
        }
      }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
    lockForm(): void {
        this.isLocked = true;
        setTimeout(() => {
            this.attempts = 0;
            this.isLocked = false;
        }, this.cooldownTime * 1000); // Unlock after cooldown
    }
}
